import React from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { clearCartData } from 'store/cartSlice';
import { getTicketsPageLink } from 'utils/events';

const CartCancelRedirect = () => {
  const {
    state: { eventId, eventName, type },
  } = useLocation();
  const dispatch = useDispatch();

  const ticketSalePageLink = `${getTicketsPageLink(
    eventName,
    eventId,
    type,
  )}?errorCode=anErrorOccured`;

  dispatch(clearCartData());

  return <Navigate to={ticketSalePageLink} />;
};

export default CartCancelRedirect;
